import React from "react";
import { Gallery, GalleryItem, Divider } from "@patternfly/react-core";
import isEmpty from "lodash/isEmpty";

import ProductGroupCard from "./ProductGroupCard";

const ProductGroupGallary = (props) => {
  const productGroups = props.productGroups;
  const publicGroups = productGroups.filter((p) => !p.is_draft);
  const draftGroups = productGroups.filter((p) => !!p.is_draft);

  const minWidths = {
    md: "100px",
    lg: "150px",
    xl: "200px",
    "2xl": "300px",
  };
  const maxWidths = {
    md: "150px",
    lg: "200px",
    xm: "250px",
    "2xl": "350px",
  };

  return (
    <>
      <Gallery
        hasGutter
        minWidths={minWidths}
        maxWidths={maxWidths}
        style={{ paddingTop: "1.5rem", paddingBottom: "1.5rem" }}
      >
        {publicGroups.map((productGroup, index) => {
          if (!isEmpty(productGroup.name) || !isEmpty(productGroup.products)) {
            return (
              <GalleryItem key={index}>
                <ProductGroupCard productGroup={productGroup} />
              </GalleryItem>
            );
          }
        })}
      </Gallery>
      <Divider component="div" />
      <Gallery
        hasGutter
        minWidths={minWidths}
        maxWidths={maxWidths}
        style={{ paddingTop: "1.5rem" }}
      >
        {draftGroups.map((productGroup, index) => {
          if (!isEmpty(productGroup.name) || !isEmpty(productGroup.products)) {
            return (
              <GalleryItem key={index}>
                <ProductGroupCard productGroup={productGroup} />
              </GalleryItem>
            );
          }
        })}
      </Gallery>
    </>
  );
};

export default ProductGroupGallary;
